<template>
  <div class="vh-100 bg-light">
    <h5 class="text-center text-darked px-3 pt-4 m-0">
      <span class="material-icons align-middle">
        contact_support
      </span>
      {{ getSkillName.text }}
    </h5>
    <div v-if="getRateQuestionList && getRateQuestionList.length">
      <span v-for="(item, idx) in getRateQuestionList" :key="idx">
        <multiple-choice
          v-if="item.type_question == 1"
          v-show="count == idx + 1"
          :options="item.option_answers"
          :type="item.type_question_text"
          :question="item.question"
          :index="idx + 1"
          :total="setTotalQuestions()"
          :id="item.id"
          :ref="`question${item.id}`"
        />
        <single-choice
          v-if="item.type_question == 2"
          v-show="count == idx + 1"
          :type="item.type_question_text"
          :options="item.option_answers"
          :question="item.question"
          :index="idx + 1"
          :total="setTotalQuestions()"
          :id="item.id"
          :ref="`question${item.id}`"
        />
      </span>
    </div>
    <div class="px-3 pt-4" v-else>
      <empty-module
        class="empty-module"
        title="Oops, it looks like there is no quiz assigned to this skill..."
        :icon="'face'"
      />
    </div>
  </div>
</template>
<script>
import EmptyModule from '@/components/general/emptyModule.vue';
import multipleChoice from '@/components/rate/multipleChoice.vue';
import singleChoice from '@/components/rate/singleChoice.vue';
import { mapGetters, mapActions } from 'vuex';
import store from '@/store';

export default {
  components: {
    multipleChoice,
    singleChoice,
    EmptyModule,
  },
  data() {
    return {
      Mid: this.$route.params.Mid,
      count: 1,
    };
  },
  methods: {
    ...mapActions('planning', ['updateRateSkillState']),
    setTotalQuestions() {
      return this.getRateQuestionList.length;
    },
    sendData() {
      this.getRateQuestionList.forEach((element) => {
        let id = parseInt(element.id, 10);
        let vueComponent = this.$refs['question' + id][0];
        if (vueComponent.correctAnswer) {
          this.updateRateSkillState({
            parent: this.getUserId,
            skill: this.Mid,
            completed: true,
          });
        }
      });
      this.$router.push({ name: 'PlanDescription', params: { Mid: this.Mid } });
    },
  },
  computed: {
    ...mapGetters('planning', ['getRateQuestionList', 'getSkillName']),
    ...mapGetters('user', ['getUserId']),
  },
  beforeRouteEnter(to, from, next) {
    let skill = to.params.Mid;
    Promise.all([
      store.dispatch('planning/FetchRateQuestionList', skill),
      store.dispatch('planning/FetchSkillName', skill),
    ]).then(() => {
      next();
    });
  },
};
</script>
